import { ArrowRightIcon, Button, Table, TableColumns } from '@bp/ui-components';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { ColorType } from 'components/PlanungImport/types';
import { useTranslation } from 'react-i18next';
import { getColorName } from 'utils/colorHelper';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { naturalStringSort } from '../../../utils/stringHelper';

export const AbsenceEvaluationClassesTableFragment = graphql(`
  fragment AbsenceEvaluationClassesTableFields on Query {
    classes(where: $classesWhere) {
      __typename
      uuid
      name
      grade
      color
    }
  }
`);

type AbsenceEvaluationClassesTableProps = {
  onNavigate: (classUuid: string) => void;
  query: FragmentType<typeof AbsenceEvaluationClassesTableFragment> | undefined;
};

type AbsenceEvaluationClassesTableType = {
  uuid: string;
  name: string;
  color: ColorType;
};

export const AbsenceEvaluationClassesTable = ({ onNavigate, query }: AbsenceEvaluationClassesTableProps) => {
  const { t } = useTranslation();

  const fragment = getFragmentData(AbsenceEvaluationClassesTableFragment, query);
  const classes = fragment?.classes ?? [];

  const columns: TableColumns<AbsenceEvaluationClassesTableType>[] = [
    {
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
      header: t('classes.title', { count: 1 }),
    },
    {
      id: 'color',
      accessorKey: 'color',
      type: 'color',
      header: t('common.color'),
    },
  ];

  const data: AbsenceEvaluationClassesTableType[] = classes
    .sort((a, b) => {
      return naturalStringSort(a.grade, b.grade);
    })
    .map((c) => ({
      uuid: c.uuid,
      name: c.name ?? '',
      color: {
        color: c.color ?? '',
        colorLabel: getColorName(c.color ?? ''),
      },
    }));

  return (
    <Table<AbsenceEvaluationClassesTableType>
      isDesktop={true}
      data={data}
      columns={columns}
      showShadow
      showBorderRadius
      showRowHover
      onRowClick={(_event, row) => onNavigate(row.original.uuid)}
      lastCol={() => <Button hierarchy='ghost' icon={<ArrowRightIcon />} />}
    />
  );
};
